import React from 'react';
import PropTypes from 'prop-types';
// material
import { visuallyHidden } from '@mui/utils';
import {
  Box, TableRow, TableCell, TableHead, TableSortLabel, useTheme, alpha, Typography,
} from '@mui/material';

// ----------------------------------------------------------------------

export default function UserListHead({
  order,
  orderBy,
  headLabel,
  onRequestSort,
}) {
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  const theme = useTheme();

  return (
    <TableHead sx={{ bgcolor: theme.palette.grey[100], borderTop: '1px solid', borderColor: theme.palette.grey[200] }}>
      <TableRow>
        {headLabel.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.alignRight ? 'right' : 'left'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              hideSortIcon
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              <Typography variant="secondary" sx={{ color: theme.palette.grey[600] }}>{headCell.label}</Typography>
              {orderBy === headCell.id ? (
                <Box sx={{ ...visuallyHidden }}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

UserListHead.propTypes = {
  order: PropTypes.oneOf(['asc', 'desc']),
  orderBy: PropTypes.string,
  headLabel: PropTypes.arrayOf(PropTypes.shape({})),
  onRequestSort: PropTypes.func,
};

UserListHead.defaultProps = {
  order: 'asc',
  orderBy: '',
  headLabel: [],
  onRequestSort: undefined,
};
